import {
    apiType,
    PLATFORM_SMARTTV,
    STREAMIQ_API_TYPE,
    TOYA_API_TYPE,
} from '../constants'

const platform = process.env.REACT_APP_PLATFORM || 'web'

export const isStreamIQ = (): boolean => apiType === STREAMIQ_API_TYPE
export const isToya = (): boolean => apiType === TOYA_API_TYPE
export const isSmartTV = (): boolean => platform === PLATFORM_SMARTTV
export const isApiType = (type: string): boolean => apiType === type
